// extracted by mini-css-extract-plugin
module.exports = {"aside":"CategoriesAside_aside__Ni9hK","parentIsSticky":"CategoriesAside_parentIsSticky___NCFO","noOverflow":"CategoriesAside_noOverflow__f3FKX"};